export default __webpack_public_path__ + "static/media/minus_icon_enable.6bdd2ca6.svg";